<template>
  <div class="thank-you-container">
    <div class="img-container">
      <div class="envelope" />
      <div class="text-container">
        <div class="thanks">Thank you!</div>
        <div class="description">Our managers will get in touch with you as soon as possible</div>
      </div>
    </div>
    <div class="btn-container">
      <a href="/">
        <div class="arrow-container">
          <span class="arrow first" />
          <span class="arrow second" />
          <span class="arrow third" />
        </div>
        <span class="btn-text">Back</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThankYou",
};
</script>

<style lang="scss" scoped>
  .thank-you-container {
    background-image: url('../assets/img/thank-you-bg.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: calc(100vh - 100px);
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .img-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
      .envelope {
        background-image: url('../assets/img/envelope.svg');
        width: 585px;
        height: 189px;
      }
      .text-container {
        font-family: Roboto;
        font-style: normal;
        margin-top: 50px;
        display: flex;
        align-items: center;
        flex-direction: column;
        .thanks {
          font-weight: bold;
          font-size: 72px;
          line-height: 100%;
          text-align: center;
          text-transform: uppercase;
          color: #FFFFFF;
        }
        .description {
          font-weight: normal;
          font-size: 24px;
          margin-top: 20px;
          line-height: 130%;
          text-align: center;
          text-transform: uppercase;
          color: #FFFFFF;
          opacity: 0.6;
          max-width: 60%;
        }
      }
    }
    .btn-container {
      width: 160px;
      height: 45px;
      box-sizing: border-box;
      border: 1px solid #1899E1;
      border-radius: 40px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      a {
        text-decoration: none;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: flex-start;
        .arrow-container {
          transform: rotate(90deg);
          width: 39px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: 23px;
          .arrow {
            display: block;
            transform: rotate(45deg);
            width: 10px;
            height: 10px;
            border-right: 3px solid #ffffff;
            border-bottom: 3px solid #ffffff;
            animation: mouse-scroll 1s infinite;
          }
          .first {
            animation-direction: alternate;
            animation-delay: alternate;
          }
          .second {
            animation-delay: .2s;
            animation-direction: alternate;
          }
          .third {
            animation-delay: .3s;
            animation-direction: alternate;
          }
        }
        .btn-text {
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 24px;
          line-height: 28px;
          text-align: center;
          text-transform: uppercase;
          color: #FFFFFF;
          margin-left: 18px;
        }
      }
    }
  }

  @keyframes mouse-scroll {

    0% {
        opacity: 0;
    }

    50% {
        opacity: .5;
    }

    100% {
        opacity: 1;
    }
  }

  @media screen and (max-width: 1024px) and (orientation: portrait) {
    .thank-you-container {
      height: calc(100vh - 80px);
      .img-container {
        .envelope {
          transform: scale(0.8);
        }
        .text-container {
          .thanks {
            font-size: 64px;
          }
        }
      }
    }
  }

    @media screen and (max-width: 1024px) and (orientation: landscape) {
    .thank-you-container {
      height: 100%;
      .img-container {
        .envelope {
          transform: scale(0.5);
        }
        .text-container {
          transform: translateY(-30px);
          margin-top: 0;
          .description {
            font-size: 20px;
          }
        }
      }
      .btn-container {
        margin: 10px auto;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .thank-you-container {
      .img-container {
        .text-container {
          .description {
            max-width: 60%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 675px) {
    .thank-you-container {
      .img-container {
        .text-container {
          .description {
            max-width: 70%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 480px) {
    .thank-you-container {
      height: calc(100vh - 65px);
      .img-container {
        .envelope {
          transform: scale(0.59);
        }
        .text-container {
          .thanks {
            font-size: 36px;
          }
          .description {
            max-width: 80%;
            font-size: 20px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 414px) {
    .thank-you-container {
      .img-container {
        .text-container {
          .description {
            max-width: 90%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 375px) {
    .thank-you-container {
      .img-container {
        .envelope {
          transform: scale(0.5);
        }
        .text-container {
          .thanks {
            font-size: 30px;
          }
          .description {
            font-size: 16px;
            max-width: 80%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 320px) {
    .thank-you-container {
      .img-container {
        .text-container {
          .description {
            max-width: 90%;
          }
        }
      }
    }
  }

</style>
